import {
  httpClient,
  HttpRequestType,
  HttpRequestParamsInterface,
} from '../../../../http-client';
import {ContactsApiClientUrlsInterface} from './ContactsApiClientUrls.interface';
import {ContactsApiClientInterface} from './ContactsApiClient.interface';
import {ContactInterface} from '../../..';

export class ContactsApiClientModel implements ContactsApiClientInterface {
  private readonly urls!: ContactsApiClientUrlsInterface;
  private readonly mockDelay: number = 0;

  constructor(options: {
    urls: ContactsApiClientUrlsInterface;
    mockDelay?: number;
  }) {
    this.urls = options.urls;
    if (options.mockDelay) {
      this.mockDelay = options.mockDelay;
    }
  }

  fetchContacts(): Promise<ContactInterface[]> {
    const requestParameters: HttpRequestParamsInterface = {
      requestType: HttpRequestType.get,
      url: this.urls.fetchContacts,
      requiresToken: false,
    };

    return httpClient.request<ContactInterface[]>(requestParameters);
  }

  createContact(data: ContactInterface): Promise<ContactInterface[]> {
    const requestParameters: HttpRequestParamsInterface = {
      requestType: HttpRequestType.post,
      url: this.urls.createContact,
      requiresToken: false,
      payload: data,
    };

    console.log(this.urls);

    return httpClient.request<ContactInterface[]>(requestParameters);
  }
}
